






















import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { prefList } from '../prefList';
import TouristSpots from '@/components/TouristSpots.vue';

 @Component({ components: { TouristSpots } })
export default class Result extends Vue {
  cityCodeList = { data: { message: null, result: [], statusCode: 0 }, status: 0 }

  all:any[] = []

  prefCode: number = 0

  prefName = ''

  cityResult = { cityCode: '' }

  apiKey:string = process.env.VUE_APP_API_KEY

  config = {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': this.apiKey,
    },
  }

  fetchCity: boolean = false

  error: string = ''

  draftSpotData:any[] = []

  isDisplayedResult: boolean = false

  mounted() {
    this.calculateDestination();
  }

  back() {
    this.$router.push('/');
  }

  async calculateDestination() {
    this.prefCode = Math.floor((Math.random() * 47) + 1);
    this.prefName = prefList[this.prefCode - 1];
    await axios
      .get(`https://opendata.resas-portal.go.jp/api/v1/cities?prefCode=${this.prefCode}`, this.config)
      .then((response) => { this.cityCodeList = response; })
      .catch((error) => { console.log(error); });
    this.fetchCity = true;

    if (this.checkNotError()) {
      const randomCity = Math.floor(Math.random() * this.cityCodeList.data.result.length);
      this.cityResult = this.cityCodeList.data.result[randomCity];
    }
    await this.fetchSpotData(this.cityResult.cityCode);
  }

  async fetchSpotData(cityCode: string) {
    this.draftSpotData = await fetch(`./data/${cityCode}.json`)
      .then(response => response.json());
  }

  get spotData() {
    return this.draftSpotData;
  }

  get displayErrorMessage() {
    return this.error;
  }

  checkNotError() {
    if (this.cityCodeList.data.statusCode) {
      if (this.cityCodeList.data.statusCode === 429) {
        this.error = 'しばらく時間をおいてから試してみてください';
      } else {
        this.error = '行き先を決められませんでした';
      }
      return false;
    }
    return true;
  }

  isLoadedSuccess() {
    this.isDisplayedResult = true;
  }

  async reCalculation() {
    if (this.error) {
      this.error = '';
    }
    await this.calculateDestination();
  }
}
